import React from 'react';
import { withRouter } from 'react-router-dom';

import { useGetRecords } from 'root/admin/components/hooks';
import { Title, CreateNew } from 'root/admin/components';

import { Loader, Table, Column } from '@smartplatform/ui';
const EditRecipients = ({ match, rootPath, tabName }) => {
	const { id } = match.params;
	const records = useGetRecords({ model: 'AwardYear', tabName });

	if (!records) {
		return <Loader />;
	}

	console.log(records);
	return (
		<div>
			<Title records={records} name="Годы присуждения" />
			<CreateNew link={`${rootPath}/${id}/awardyears/new`} name="Добавить год" />

			<Table records={records} rootPath={`${rootPath}/${id}`}>
				<Column property="name" label="Год" />
			</Table>
		</div>
	);
};

export default withRouter(EditRecipients);
